module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/postcode.js
// module id = 1439
// module chunks = 0